<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30"
      >
        <h3 class="mb-0">Item By Category</h3>
      </div>

      <ul class="ps-0 mb-0 list-unstyled">
        <li
          class="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom list-item-category"
          v-for="item in listItemCategory"
          :key="item.name"
          @click="goToGroupCategory(item)"
        >
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 ms-2">
              <h6 class="fw-medium fs-16 mb-0">{{ item?.name }}</h6>
            </div>
          </div>
          <span class="fs-18 fw-medium text-secondary">{{ item?.total }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { useDashboardStore } from "@/stores/dashboard/general";
import { DashboardItemByCategory } from "@/types/interface/dashboard";
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "ItemByCategory",
  setup() {
    const storeDashboard = useDashboardStore();
    const listItemCategory = ref();
    const router = useRouter();

    const loadItemByCategory = async () => {
      const { success } = await storeDashboard.dispatchItemByCategory();
      if (success) {
        listItemCategory.value = storeDashboard.itemCategory;
      }
    };

    onMounted(() => {
      loadItemByCategory();
    });

    const goToGroupCategory = (item: any) => {
      router.push("/dashboard/item-group-category/" + item.code);
    };

    return {
      listItemCategory,
      loadItemByCategory,
      goToGroupCategory,
    };
  },
});
</script>

<style scoped>
.list-item-category {
  cursor: pointer;
}
</style>
